import {
	HostListener,
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ChangeDetectorRef
} from "@angular/core";
import { Router, NavigationStart, NavigationEnd } from "@angular/router";
import { GlobalService } from "../../services/global/global.service";

import { Observable, BehaviorSubject } from "rxjs";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
@Component({
	selector: "app-footer",
	templateUrl: "./footer.component.html",
	styleUrls: ["./footer.component.css"],
	changeDetection: ChangeDetectionStrategy.Default
})
export class FooterComponent implements OnInit {
	public isPrivacyOpen: boolean = false;
	public isHomePage: boolean = false;
	public isFooterHide = new BehaviorSubject<boolean>(false);
	public currentYear: number = Date.now();
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService,
		private cd: ChangeDetectorRef
	) {}

	@HostListener("window:beforeunload", ["$event"])
	unloadNotification($event: any) {
		if (
			$event.path[0].location.pathname !== "/home" &&
			$event.path[0].location.pathname !== ""
		) {
			$event.returnValue = true;
		}
	}

	ngOnInit() {
		this.router.events.subscribe(val => {
			if (val instanceof NavigationStart) {
				if (val.url === "/home") {
					setTimeout(() => (this.isHomePage = true), 0);
				} else {
					setTimeout(() => (this.isHomePage = false), 0);
				}
			}
			if (val instanceof NavigationEnd) {
				if ("/about" === val.url) {
					this.isFooterHide.next(true);
				} else {
					this.isFooterHide.next(false);
				}

				this.globalService.routerLastUrl = this.globalService.routerCurrentUrl;
				this.globalService.routerCurrentUrl = val.url;
				if (
					[
						"/log-in",
						"/create-account",
						"/account-faqs",
						"/profile",
						"/account-created",
						"/edit-contact-info",
						"/edit-payment-method",
						"/change-email-address",
						"/change-password",
						"/contact-info",
						"/notifications",
						"/payment-methods",
						"/reset-password",
						"/select-payment-method",
						"/billing-account",
						"/reset-password-sucess",
						"/password-changed",
						"/email-address-changed"
					].indexOf(this.globalService.routerLastUrl) < 0
				) {
					this.globalService.userActionCallFrom = this.globalService.routerLastUrl;
				}
				window.scrollTo(0, 0);
				this.cd.markForCheck();
			}
		});
	}
	public openPrivacy() {
		this.isPrivacyOpen = true;
	}
	public closePrivacy() {
		this.isPrivacyOpen = false;
	}
}
